// Pages/Login/LoginPage.jsx
import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Paper,
  Box,
  Typography,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

import image1 from "../../Assets/Images/image1.jpg";
import image2 from "../../Assets/Images/image2.jpg";
import image3 from "../../Assets/Images/image3.jpg";
import pngwing from "../../Assets/Logo/pngwing.png";

const images = [image1, image2, image3];

const LoginPage = ({ onLogin }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [showPassword, setShowPassword] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  const onSubmit = (data) => {
    const { identifier, password } = data;
    if (identifier === "User@gmail.com" && password === "User@123") {
      toast.success("Login successful!");
      localStorage.setItem("isLoggedIn", "true");
      onLogin();
      navigate("/");
    } else {
      toast.error("Invalid email or password");
    }
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        overflow: "hidden",
        justifyContent: "center",
        alignItems: "center",
        padding: 2,
        bgcolor: "#f2f2f2",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          borderRadius: "20px",
          overflow: "hidden",
          maxWidth: 900,
          width: "100%",
          height: 500,
          display: "flex",
        }}
      >
        <Grid container sx={{ flexDirection: { xs: "column", md: "row" } }}>
          {/* Left Side Form */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              bgcolor: "#fff",
              padding: "40px 30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flex: 1,
            }}
          >
            <Box sx={{ width: "100%", maxWidth: 350 }}>
              <Box
                 sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                // mb: 4,
                mt: -2,
              }}
              >
                <Box
                component="img"
                src={pngwing}
                alt="Yoga Logo"
                sx={{ width: 80, height: 80, objectFit: "contain", mb: 1 }}
              />
                <Typography variant="h5" sx={{ fontWeight: "bold", color: "#106870" }}>
                  Sign In
                </Typography>
                <Typography variant="body2" sx={{ mt: 1, color: "#555" }}>
                Welcome back! Please enter your detail
              </Typography>
              </Box>

              <form onSubmit={handleSubmit(onSubmit)} noValidate>
                <Controller
                  name="identifier"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Email or Mobile Number is required" }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Email Or Mobile Number*"
                      fullWidth
                      error={!!errors.identifier}
                      helperText={errors.identifier?.message}
                      variant="outlined"
                      margin="normal"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                        },
                      }}
                    />
                  )}
                />
                <Controller
                  name="password"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Password is required" }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Password*"
                      fullWidth
                      type={showPassword ? "text" : "password"}
                      error={!!errors.password}
                      helperText={errors.password?.message}
                      variant="outlined"
                      margin="normal"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                        },
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() =>
                                setShowPassword((show) => !show)
                              }
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
                <Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mt: 1,
    mb: 1,
  }}
>
  {/* Left side: Remember me */}
  <Box display="flex" alignItems="center">
    <input type="checkbox" style={{ marginRight: 8 }} />
    <Typography variant="body2" sx={{ color: "#888" }}>
      Remember me 
    </Typography>
  </Box>

  {/* Right side: Forgot password */}
  <Typography
    variant="body2"
    sx={{ color: "#1976d2", cursor: "pointer", "&:hover": { textDecoration: "underline" } }}
    onClick={() => navigate("/forgot-password")}
  >
    Forgot Password?
  </Typography>
</Box>

                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{
                    bgcolor: "#16919c",
                    color: "white",
                    fontWeight: "bold",
                    mt: 2,
                    py: 1.2,
                    borderRadius: 2,
                    textTransform: "none",
                    "&:hover": {
                      bgcolor: "#106870",
                    },
                  }}
                >
                  Sign in
                </Button>
                <Typography
  variant="body2"
  sx={{
    mt: 2,
    textAlign: "center",
    color: "#888",
  }}
>
  Don't have an account?{" "}
  <Box
    component="span"
    sx={{
      color: "#1976d2",
      fontWeight: 500,
      cursor: "pointer",
      "&:hover": { textDecoration: "underline" },
    }}
    onClick={() => navigate("/signup")}
  >
    Sign Up
  </Box>
</Typography>

              </form>
            </Box>
          </Grid>

          {/* Right Side Image Carousel */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{ position: "relative", flex: 1, height: { xs: 250, md: "auto" } }}
          >
            <Box sx={{ width: "100%", height: "100%", position: "relative" }}>
              <Box
                component="img"
                src={images[currentIndex]}
                alt={`slide-${currentIndex}`}
                sx={{
                  height: "100%",
                  width: "100%",
                  objectFit: "cover",
                }}
              />

              {/* Arrows */}
              <IconButton
                onClick={handlePrev}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: 10,
                  transform: "translateY(-50%)",
                  backgroundColor: "rgba(0,0,0,0.4)",
                  color: "white",
                  borderRadius: "50%",
                  zIndex: 2,
                }}
              >
                <ArrowBackIosNewIcon />
              </IconButton>
              <IconButton
                onClick={handleNext}
                sx={{
                  position: "absolute",
                  top: "50%",
                  right: 10,
                  transform: "translateY(-50%)",
                  backgroundColor: "rgba(0,0,0,0.4)",
                  color: "white",
                  borderRadius: "50%",
                  zIndex: 2,
                }}
              >
                <ArrowForwardIosIcon />
              </IconButton>

              {/* Dots */}
              <Box
                sx={{
                  position: "absolute",
                  bottom: 20,
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  gap: 1,
                }}
              >
                {images.map((_, index) => (
                  <Box
                    key={index}
                    sx={{
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      bgcolor: index === currentIndex ? "#000" : "#ccc",
                    }}
                  />
                ))}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default LoginPage;
